import { cbgabout } from "../../content/content";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useEffect, useRef } from "react";
import useGsapAnimations from "../../../hooks/useGsapAnimations"; 

const Cbgabout = () => {
  const refs = {
    imageSection: useRef(null),
    textSection: useRef(null),
    details: useRef(null),
    points: useRef(null),
  };

  useGsapAnimations(refs);

  return (
    <div className="flex flex-col md:flex-row items-center md:items-start md:px-16 mt-16 mb-16">
      {/* Image Section */}
      <div
        ref={refs.imageSection}
        className="flex justify-center md:ml-10 ml-6 mr-6 md:mr-0 md:mx-0 mb-6 md:mb-0 relative"
      >
        <img
          src={cbgabout.cbgmage2}
          alt="AI Illustration"
          className="w-6/6 object-cover rounded-2xl"
        />
        <div className="absolute top-20 w-48 h-60 left-0 md:left-[-50px] bg-yellow-400 text-white p-5 rounded-xl shadow-lg flex flex-col items-center">
          <img
            src={cbgabout.clienticon}
            alt="Happy Clients"
            className="w-16 h-16 invert text-white mb-2"
          />
          <div className="pt-6 font-bold">
            {/* <h2 className="text-3xl font-bold text-center">Capacity 14 TPD</h2> */}
            <p className="text-md">- Capacity 14 TPD</p>
            <p className="text-md">- Area 22 Acres</p>
          </div>
        </div>
      </div>

      {/* Text Section */}
      <div ref={refs.textSection} className="w-11/12 max-w-5xl md:ml-0 ml-[-33px] px-0 md:px-4 flex flex-col">
        <div className="ml-10">
          <button className="w-fit md:px-4 h-10 items-center text-md rounded-md bg-green-200 text-green-800">
            Complete Commercial And Residential Solar Systems
          </button>
          <h2 className="text-2xl text-start mb-4 mt-3 md:text-4xl font-bold text-gray-900">
            {cbgabout.title1} <span className="text-blue-600">{cbgabout.title2}</span>
          </h2>
        </div>

        <div className="flex flex-col md:flex-row md:justify-between">
          {/* Left Section */}
          <div ref={refs.details} className="md:w-2/3 ml-10">
            <p className="mt-4 text-gray-600 text-sm md:text-lg font-semibold font-sans">
              {cbgabout.description1}
            </p>
            <p className="mt-4 text-gray-700 text-sm font-sans md:text-md">
              {cbgabout.description2}
            </p>
            <div className="mt-6">
              {/* <button
                onClick={() => (window.location.href = "http://localhost:3000/synergy-dg")}
                className="px-6 py-4 mt-4 md:mt-0 mb-4 md:mb-0 bg-gray-900 text-white font-semibold rounded hover:bg-gray-800 flex items-center"
              >
                Read More <span className="ml-2">→</span>
              </button> */}
            </div>
          </div>

          {/* Right Section */}
          <div ref={refs.points} className="md:w-[44%] ml-10 md:mt-4">
            <h3 className="text-md font-sans text-gray-800">{cbgabout.subtitle}</h3>
            <ul className="mt-4">
              {[cbgabout.points1, cbgabout.points2, cbgabout.points3].map((point, index) => (
                <li key={index} className="flex items-start mb-2">
                  <IoIosCheckmarkCircle className="text-green-500 h-8 w-8" />
                  <p className="text-sm md:text-md font-sans text-gray-800 ml-2">{point}</p>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cbgabout;
